<div class="free-plan" [ngClass]="theme + ' tooltip-wrapper'">
  <span>Free plan</span>
  <span>•</span>
  <a href="mailto:sales@xostrucks.com">Upgrade</a>
</div>
